import React from 'react';
import image from '../../image/image.png'
import internet from '../../image/internet.png'

const PictoBadge = (props) => {
    return (
        <>
            {(props.type === 'image' && props.image !== "") && (
                <img className="p-icon__picto" src={image} alt={"Pictogram of image"} />
            )}
            {(props.type === 'internet' && props.url !== "") && (
                <img className="p-icon__picto" src={internet} alt={"Pictogram of internet"} />
            )}
        </>
    );
};

export default PictoBadge;